import { GetWeavePopNotificationByType } from '@frontend/types';
import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotificationActionSubscription } from './actions/use-notification-action-subscription';
import { useNotification } from './use-notification';

type Props = {
  onView?: (payload: GetWeavePopNotificationByType<'inbox-robocall-tag'>) => void;
};

export const useInboxRobocallTagNotification = ({ onView }: Props = {}) => {
  useCommonActionSubscriptions('inbox-robocall-tag');
  const { create, remove } = useNotification<'inbox-robocall-tag'>();
  useNotificationActionSubscription('inbox-robocall-tag', 'ignore', (e) => {
    remove(e.notification.id);
  });

  useNotificationActionSubscription('inbox-robocall-tag', 'timed-out', (e) => {
    remove(e.notification.id);
  });

  useNotificationActionSubscription(
    'inbox-robocall-tag',
    'view',
    ({ notification }) => {
      onView?.(notification);
      remove(notification.id);
    },
    [onView]
  );

  return {
    create,
    remove,
  };
};
